<template>
  <div class="ma-4 px-4">
    <v-row class="pr-3">
      <v-col cols="12" md="2">
        <v-select
          v-model="form.year_batch"
          :items="batches"
          clearable
          outlined
          dense
          hide-details="auto"
          label="Batch"
        ></v-select>
      </v-col>
      <v-col cols="12" md="2">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="displayDate"
              readonly
              outlined
              label="Date Range"
              dense
              v-bind="attrs"
              v-on="on"
              hide-details="auto"
            ></v-text-field>
          </template>
          <v-sheet
            class="pa-4"
            elevation="4"
            style="background-color: white; border-radius: 8px"
          >
            <v-row no-gutters>
              <v-col>
                <v-date-picker
                  v-model="selectedDates"
                  range
                  @input="onDateChange"
                ></v-date-picker>
              </v-col>
              <v-col class="pl-4 pt-4" style="max-width: 150px">
                <div
                  v-for="option in dateOptions"
                  :key="option.label"
                  class="mb-2 pt-2"
                >
                  <v-btn small color="accent" @click="setQuickDate(option)">
                    {{ option.label }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-menu>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="form.pv_number"
          hide-details="auto"
          label="PV Number"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="form.transaction_id"
          hide-details="auto"
          label="Transaction ID"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4"
        ><v-btn class="accent white--text" :loading="loading" @click="searchFilter">
          Search
        </v-btn>
        <v-btn
          @click="download()"
          :disabled="!settlements.length"
          class="accent white--text ml-2"
        >
          <v-icon>mdi-download</v-icon> Download
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="finalSettlementHeaders"
            :search="search"
            :items="settlements"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.settled_transactions`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="navigate(item)">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <template #[`item.date`]="{ value }">
              {{ formatDate(value, false) }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800px">
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createSettlement"
        @update="updateSettlement"
        :settlement="settlement"
        :edit="editMode"
      />
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/settlement/form.vue";
import searchBar from "@/components/searchBar.vue";
import { settlementHeaders } from "@/constants/headers";
export default {
  components: {
    formDialog,
    searchBar,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      settlement: {},
      currentItem: {},
      settlements: [],
      search: "",
      headers: settlementHeaders,
      form: {
        from_date: "",
        to_date: "",
      },
      menu: false,
      selectedDates: [],
      displayDate: "",
      dateOptions: [
        { label: "Today", days: 0 },
        { label: "Yesterday", type: "yesterday" },
        { label: "This Week", type: "week" },
        { label: "Last 7 Days", days: 6 },
        { label: "This Month", type: "month" },
        { label: "Last 30 Days", days: 29 },
        { label: "Reset", type: "reset" },
      ],
      batches: [],
      finalSettlementHeaders: [],
      loading: false,
    };
  },
  watch: {},
  computed: {},
  async created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Settlements" }]);
    await this.generateBatchList();
    this.initialise();
  },
  methods: {
    initialise() {
      this.searchFilter();
      this.finalSettlementHeaders = this.injectCustomSort(
        this.headers,
        ["date"]
      );
    },
    async getSettlements(queryString) {
      this.loading = true;
      await this.$axios
        .get(`settlements?${queryString}`)
        .then((res) => {
          this.settlements = res.data.data.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.loading = false;
        })
        .catch(async (error) => {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            message: error.response.data.message || "No Data Found",
            color: "error",
          });
        });
    },
    async createSettlement(settlement) {
      await this.$axios
        .post("settlements", { settlement: settlement })
        .then((res) => {
          this.$store.commit("showSnackbar", {
            message: "Settlement created successfully",
            color: "success",
          });
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: "Settlement failed to create",
            color: "error",
          });
        });
    },
    async updateSettlement(settlement) {
      await this.$axios
        .put(`settlements/${settlement.id}`, { settlement: settlement })
        .then((res) => {
          this.$store.commit("showSnackbar", {
            message: "Settlement updated successfully",
            color: "success",
          });
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: "Settlement failed to update",
            color: "error",
          });
        });
    },
    edit(item) {
      this.settlement = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.currentItem = {};
      this.settlement = {};
    },
    customFilter(value, search, item) {
      search = search.toLowerCase();
      if (!search) return true;
      return (
        item.pv_number.toLowerCase().includes(search) ||
        item.date.toLowerCase().includes(search) ||
        item.net_credit.toString().includes(search) ||
        item.total_gross_amount.toString().includes(search) ||
        item.total_charge_back_amount.toString().includes(search) ||
        item.total_refund_amount.toString().includes(search) ||
        item.escrow_tx_amount.toString().includes(search) ||
        item.charges.toString().includes(search) ||
        item.gst.toString().includes(search) ||
        item.settled_amount.toString().includes(search)
      );
    },
    navigate(item) {
      this.$router.push({
        path: `/settlements/${item.pv_number}/transactions`,
      });
    },
    formatDate(dateString, needHour) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hour = date.getHours().toString().padStart(2, "0");
      const minute = date.getMinutes().toString().padStart(2, "0");
      return needHour
        ? `${month}-${day}-${year} ${hour}:${minute}`
        : `${day}-${month}-${year}`;
    },
    async download() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      this.$axios
        .get(`/download_collection_report?${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Settlements.csv");
          document.body.appendChild(link);
          link.click();
        });
    },
    onDateChange() {
      if (this.selectedDates.length === 2) {
        const [fromDate, toDate] = this.selectedDates;
        this.form.from_date = this.formatDateBackend(fromDate);
        this.form.to_date = this.formatDateBackend(toDate);
        this.displayDate = this.formatDisplayDate(fromDate, toDate);
      }
    },
    setQuickDate(option) {
      const today = new Date();
      let fromDate = new Date(today);
      let toDate = new Date(today);

      if (option.type === "reset") {
        this.form.from_date = null;
        this.form.to_date = null;
        this.displayDate = "";
        this.selectedDates = [];
        return;
      }

      if (option.type === "week") {
        fromDate.setDate(today.getDate() - today.getDay());
      } else if (option.type === "month") {
        fromDate.setDate(1);
      } else if (option.type === "yesterday") {
        fromDate.setDate(today.getDate() - 1);
        toDate.setDate(today.getDate() - 1);
      } else if (option.days != null) {
        fromDate.setDate(today.getDate() - option.days);
      }

      this.selectedDates = [fromDate, toDate];
      this.onDateChange();
    },
    formatDateBackend(date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
    formatDisplayDate(fromDate, toDate) {
      const format = (d) =>
        `${String(d.getDate()).padStart(2, "0")}-${String(
          d.getMonth() + 1
        ).padStart(2, "0")}-${d.getFullYear()}`;
      return `${format(new Date(fromDate))} ~ ${format(new Date(toDate))}`;
    },
    searchFilter() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      this.getSettlements(queryString);
    },
    objectToQueryParams(obj) {
      if (obj.year_batch) {
        const [year, batch] = obj.year_batch.split("-");
        obj.year = parseInt(year, 10);
        obj.batch = parseInt(batch, 10);
        delete obj.year_batch;
      }
      return Object.keys(obj)
        .filter(
          (key) =>
            obj[key] !== undefined && obj[key] !== null && obj[key] !== ""
        )
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
        )
        .join("&");
    },
    async generateBatchList() {
      try {
        const response = await this.$axios.get("/get_year_batch");
        this.batches = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    customDateSort(a, b) {
      const dateA = new Date(a).getTime();
      const dateB = new Date(b).getTime();

      if (dateA < dateB) return -1;
      if (dateA > dateB) return 1;
      return 0;
    },
    injectCustomSort(headers, dateFields) {
      return headers.map((header) => {
        if (dateFields.includes(header.value)) {
          return { ...header, sort: this.customDateSort };
        }
        return header;
      });
    },
  },
};
</script>

<style scoped>
.v-data-table::v-deep th {
  padding-right: 0px !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  padding-right: 0px !important;
}
</style>
